<template>
    <div class="d-flex align-items-end mr-3">
      <button
        type="button"
        :class="[
          'btn btnclass smallerfontsize',
          savedProductClasses.length > 0 ? 'selected' : ''
        ]"
        @click="fieldData.showProductClassModal = true"
      >
        Product class
      </button>
      <b-modal
        @ok="saveProductClasses"
        @show="showModal"
        @hide="onHidden"
        v-model="fieldData.showProductClassModal"
        :no-close-on-backdrop="true"
        size="lg"
        id="modal-productclass"
        title="Choose Product Class"
      >
        <b-tabs content-class="px-2">
          <b-tab title="Product class">
            <div class="form-row">
              <div class="col-sm-4">
                <b-form-select
                  class="my-4"
                  size="sm"
                  :options="productName1Options"
                  v-model="productName1"
                ></b-form-select>
              </div>
              <div class="col-sm-4">
                <b-form-select
                  class="my-4"
                  size="sm"
                  :options="productName2Options"
                  v-model="productName2"
                  :disabled="!productName2Options.length"
                ></b-form-select>
              </div>
              <div class="col-sm-4">
                <b-form-select
                  class="my-4"
                  size="sm"
                  :options="productName3Options"
                  v-model="productName3"
                  :disabled="!productName3Options.length"
                ></b-form-select>
              </div>
  
              <div class="col-sm-12">
                <b-button
                  variant="success btn-sm"
                  class="my-4"
                  @click="addProductClass"
                  :disabled="!productName1"
                >
                  Add
                </b-button>
                <b-button
                  @click="removeProductClasses"
                  v-if="temporaryProductClasses.length > 1"
                  class="my-4 ml-2"
                  variant="danger"
                  size="sm"
                  >Remove all</b-button
                >
              </div>
              <b-list-group class="col-sm-12">
                <b-list-group-item
                  v-bind:key="index"
                  v-for="(productclass, index) in temporaryProductClasses"
                >
                  <span>{{ stringifyProductClass(productclass) }}</span>
                  <b-button
                    v-on:click="removeProductClass(index)"
                    class="ml-2 float-right"
                    variant="danger"
                    size="sm"
                    >Remove
                  </b-button>
                </b-list-group-item>
              </b-list-group>
            </div>
          </b-tab>
        </b-tabs>
        <template v-slot:modal-footer="{ ok, cancel }">
          <b-button size="sm" variant="outline-secondary" @click="cancel()">
            Cancel
          </b-button>
          <b-button size="sm" variant="primary" @click="ok()">
            Save
          </b-button>
        </template>
      </b-modal>
    </div>
  </template>
  
  <script>
  import props from "@/mixins/inputProps";
  export default {
    name: "ProductClassModal",
    mixins: [props],
    data() {
      return {
        productName1: null,
        productName2: null,
        productName3: null,
        temporaryProductClasses: []
      };
    },
    watch: {
      productName1: function() {
        this.productName2 = null;
      },
      productName2: function() {
        this.productName3 = null;
      }
    },
    computed: {
      productName1Options() {
        let productName1Options = [
          ...new Set(this.fieldData.config.map(p => p.productName1))
        ].sort();
        return [
          { value: null, text: "Choose an option" },
          ...productName1Options
        ];
      },
      productName2Options() {
        let productName2Options = this.fieldData.config
          .filter(
            p => p.productName1 == this.productName1 && p.productName2 !== "-"
          )
          .map(p => p.productName2);
        let productName2OptionsDistinct = [
          ...new Set(productName2Options)
        ].sort();
        if (productName2OptionsDistinct.length > 0)
          productName2OptionsDistinct.unshift({
            value: null,
            text: "Choose an option"
          });
        return productName2OptionsDistinct;
      },
      productName3Options() {
        let productName3Options = [
          this.fieldData.config
            .filter(
              p =>
                p.productName1 == this.productName1 &&
                p.productName2 == this.productName2 &&
                p.productName3 !== "-"
            )
            .map(p => p.productName3)
        ];
        let productName3OptionsDistinct = [
          ...new Set(...productName3Options)
        ].sort();
        if (productName3OptionsDistinct.length > 0)
          productName3OptionsDistinct.unshift({
            value: null,
            text: "Choose an option"
          });
        return productName3OptionsDistinct;
      },
  
      savedProductClasses() {
        let savedProductClasses = this.$store.getters[this.getter]?.[
          this.fieldData.identifier
        ]
          ? this.$store.getters[this.getter][this.fieldData.identifier]
          : [];
        return savedProductClasses;
      }
    },
    methods: {
      onKeyUp(event) {
        if (event.key === "Enter" && this.fieldData.showProductClassModal) {
          this.saveProductClasses();
          this.fieldData.showProductClassModal = false;
        }
      },
      onHidden() {
        document.removeEventListener("keyup", this.onKeyUp);
      },
      showModal() {
        this.productName1 = null;
        this.temporaryProductClasses = [...this.savedProductClasses];
        document.addEventListener("keyup", this.onKeyUp);
      },
      addProductClass() {
        const config = {
          productName1: this.productName1,
          productName2: this.productName2,
          productName3: this.productName3
        };
  
        if (
          this.temporaryProductClasses.filter(
            g =>
              g.productName1 === config.productName1 &&
              g.productName2 === config.productName2 &&
              g.productName3 === config.productName3
          ).length !== 0
        ) {
          this.$bvToast.toast("Product class already exists", {
            title: "Warning",
            variant: "warning",
            solid: true,
            autoHideDelay: 3000
          });
        } else {
          this.temporaryProductClasses.push(config);
        }
      },
      removeProductClass(index) {
        this.temporaryProductClasses.splice(index, 1);
      },
      removeProductClasses() {
        this.temporaryProductClasses = [];
      },
      stringifyProductClass(productClass) {
        return [
          productClass.productName1,
          productClass.productName2,
          productClass.productName3
        ]
          .filter(x => x)
          .join("; ");
      },
      saveProductClasses() {
        const updatedQuery = {
          ...this.$store.getters[this.getter],
          [this.fieldData.identifier]: this.temporaryProductClasses
        };
        this.$store.commit(this.setter, updatedQuery);
      }
    }
  };
  </script>
  
  <style scoped>
  label {
    width: 100%;
  }
  </style>
  